<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="门店名称" prop="bizStoreName">
          <el-input v-model="ruleForm.bizStoreName" placeholder="" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="门店省市" prop="bizAddressCode">
          <el-input v-model="ruleForm.bizAddressCode" placeholder="" clearable></el-input>
        </el-form-item> -->

        <div class="province">
          <el-form-item label="门店省市" prop="province">
            <el-select v-model="ruleForm.province" placeholder="省份" @change="changeProvince">
              <el-option v-for="item in provinceListData" :key="item.id" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="" style="margin-left: -105px">
            <el-select v-model="ruleForm.bizAddressCode" placeholder="城市">
              <el-option v-for="item in cityListData" :key="item.id" :label="item.name" :value="item.code"> </el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="门店地址" prop="bizStoreAddress">
          <div class="style">
            <el-input v-model="ruleForm.bizStoreAddress" placeholder="" clearable></el-input>
          </div>
          <p class="labels-tips">请填写详细的经营场所信息，如有多个场所，选择一个主要场所填写即可</p>
        </el-form-item>
        <el-form-item class="style" label="门店门头照片" prop="storeEntrancePic">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.storeEntrancePic && ruleForm.storeEntrancePic.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="storeEntrancePicList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return storeEntrancePicSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="style" label="店内环境照片" prop="indoorPic">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.indoorPic && ruleForm.indoorPic.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="indoorPicList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemoveIndoorPic"
                :on-success="
                  (response, file, fileList) => {
                    return indoorPicSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="线下场所对应的商家APPID" prop="bizSubAppid">
          <div class="style">
            <el-input v-model="ruleForm.bizSubAppid" placeholder="" clearable></el-input>
          </div>
          <p class="labels-tips">
            1、可填写已认证的公众号、小程序、应用的APPID，其中公众号APPID需是已认证的服务号、政府或媒体类型的订阅号。
          </p>
          <p class="labels-tips">
            2、完成进件后，系统发起特约商户号与该AppID的绑定（即配置为sub_appid，可在发起支付时传入）
          </p>
          <p class="labels-tips">（1）若APPID主体与商家主体一致，则直接完成绑定；</p>
          <p class="labels-tips">
            （2）若APPID主体与商家主体不一致，则商户签约时显示《联合营运承诺函》，并且AppID的管理员需登录公众平台确认绑定意愿；（暂不支持绑定异主体的应用APPID）
          </p>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    allData: {
      type: Object,
      default: () => {},
    },
    provinceListData: {
      type: Array,
      default: () => [],
    },
    cityListData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      storeEntrancePicList: [],
      indoorPicList: [],
      ruleForm: {
        bizStoreName: '',
        bizAddressCode: '',
        bizStoreAddress: '',
        storeEntrancePic: '',
        indoorPic: '',
        bizSubAppid: '',
        province: '',
      },
      rules: {
        bizStoreName: [{ required: true, message: '请输入门店名称', trigger: ['blur', 'change'] }],
        bizAddressCode: [{ required: true, message: '请选择门店城市', trigger: ['blur', 'change'] }],
        province: [{ required: true, message: '请选择门店省份', trigger: ['blur', 'change'] }],
        bizStoreAddress: [{ required: true, message: '请输入门店地址', trigger: ['blur', 'change'] }],
        storeEntrancePic: [{ required: true, message: '请上传门店门头照片', trigger: ['blur', 'change'] }],
        indoorPic: [{ required: true, message: '请上传店内环境照片', trigger: ['blur', 'change'] }],
        bizSubAppid: [{ required: true, message: '请填写商家APPID', trigger: ['blur', 'change'] }],
      },
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    allData: {
      handler: function (data) {
        console.log(data);
        if (data.businessDataVO) {
          this.ruleForm = JSON.parse(JSON.stringify(data.businessDataVO));
          let storeEntrancePicList = data.businessDataVO.storeEntrancePic.split(',');
          let indoorPicList = data.businessDataVO.indoorPic.split(',');
          this.storeEntrancePicList = storeEntrancePicList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
          this.indoorPicList = indoorPicList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    storeEntrancePicSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.storeEntrancePic = file.response.data.url;
      console.log(this.ruleForm.storeEntrancePic);
      this.$emit('storeEntrancePicMediaId', this.ruleForm.storeEntrancePic,file.name);
    },
    indoorPicSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.indoorPic = file.response.data.url;
      console.log(this.ruleForm.indoorPic);
      this.$emit('indoorPicMediaId', this.ruleForm.indoorPic,file.name);
    },
    handleRemove() {
      this.ruleForm.storeEntrancePic = [];
    },
    handleRemoveIndoorPic() {
      this.ruleForm.indoorPic = [];
    },
    changeProvince(val) {
      this.ruleForm.bizAddressCode = '';
      this.$emit('changeProvince', val);
      console.log(val);
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  .hint {
    font-size: 12px;
    transform-origin: left;
    transform: scale(0.9);
    color: #fe4b48;
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
.style {
  margin-bottom: 7px;
}
.province {
  display: flex;
  /deep/.el-input--suffix {
    width: 165px;
  }
}
</style>
